import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import FoodAlcoholService from '../../../services/foodAlcoholService';
import { FoodAlcoholModel } from "../../../models/foodAndAlcohol";
import { DropdownModel } from "../../../models/dropdownModel";
import { Dropdown } from 'primereact/dropdown';
import { InteractionType } from '../../../common/enums';
import { Editor } from 'primereact/editor';
import { DrugToFoodAlcoholInteractionModel } from "../../../models/activeIngredient";
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';

interface IProps {
  isVisible: boolean,
  cancelClick: any,
  okClick: any,
  currentFoodAlcoholInteraction: DrugToFoodAlcoholInteractionModel,
  currentActiveIngredientId: number,
  isFoodAlcoholDropdownDisabled: boolean,
  selectedLangId: number;
}

interface IState {
  isLoading: boolean;
  error: any;
  foodAlcoholDropdown: Array<DropdownModel>;
  interactionSeverityDropdown: Array<DropdownModel>;
  currentFoodAlcoholInteraction: DrugToFoodAlcoholInteractionModel;
}

class FoodAlcoholInteractionAddEditDialog extends React.Component<IProps, IState> {
  foodAlcoholService = new FoodAlcoholService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      foodAlcoholDropdown: Array<DropdownModel>(0),
      interactionSeverityDropdown: Array<DropdownModel>(0),
      currentFoodAlcoholInteraction: this.props.currentFoodAlcoholInteraction
    }
  }
  componentDidMount() {
    this.initData();
  }

  initData() {
    this.foodAlcoholService.getDropdownList().then(
      (data: Array<DropdownModel>) => {
        const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
        const current: DrugToFoodAlcoholInteractionModel = { ...this.state.currentFoodAlcoholInteraction };
        current.interactionTypeId = InteractionType.Major;
        this.setState({
          foodAlcoholDropdown: firstItem.concat(data),
          interactionSeverityDropdown: enumToDropdownArray(InteractionType, true),
          currentFoodAlcoholInteraction: current
        });
      })
      .catch(error => {
        this.setState({
          //error
        });
      });
  }

  handleOkButton = event => {
    event.preventDefault();

    if (!this.state.currentFoodAlcoholInteraction.foodAlcoholName) {
      let foodDropDown = this.state.foodAlcoholDropdown.find(i => i.value === this.state.currentFoodAlcoholInteraction.foodAlcoholId);
      if (foodDropDown) {
        this.state.currentFoodAlcoholInteraction.foodAlcoholName = foodDropDown.label;
      }
    }

    this.props.okClick(this.state.currentFoodAlcoholInteraction);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  handleInteractionChange = (key, value) => {
    const currentFoodAlcoholInteraction: DrugToFoodAlcoholInteractionModel = { ...this.state.currentFoodAlcoholInteraction };
    currentFoodAlcoholInteraction[key] = value;
    this.setState({ currentFoodAlcoholInteraction: { ...currentFoodAlcoholInteraction } });
  };

  getDrugToDrugValueContent = (key) => {
    let content = this.state.currentFoodAlcoholInteraction.drugToFoodAlcoholInteractionContent.find(r => r.langId == this.props.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleContentChange = (key, value) => {
    const drugInteraction: DrugToFoodAlcoholInteractionModel = { ...this.state.currentFoodAlcoholInteraction };
    let content = drugInteraction.drugToFoodAlcoholInteractionContent.find(r => r.langId == this.props.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ currentFoodAlcoholInteraction: { ...drugInteraction } });
  }

  render() {
    const { foodAlcoholDropdown, interactionSeverityDropdown, currentFoodAlcoholInteraction } = this.state;

    return (
      <Dialog header="Food and Alcohol Interaction" responsive={true} width="70%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Add" icon="pi pi-check" disabled={!currentFoodAlcoholInteraction || !currentFoodAlcoholInteraction.foodAlcoholId ||
              currentFoodAlcoholInteraction.foodAlcoholId == 0}
              onClick={this.handleOkButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>
        }>
        <div style={{ minHeight: '400px', maxHeight: '550px' }}>
          <div className="p-fluid p-grid p-md-12">
            <div className="p-col-12 p-md-6">
              <label>Food and Alcohol:</label>
              <Dropdown
                disabled={this.props.isFoodAlcoholDropdownDisabled}
                value={currentFoodAlcoholInteraction && currentFoodAlcoholInteraction.foodAlcoholId ? currentFoodAlcoholInteraction.foodAlcoholId : -1}
                options={foodAlcoholDropdown}
                onChange={(e) => this.handleInteractionChange('foodAlcoholId', e.value)}
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-md-6">
              <label>Interaction severity:</label>
              <Dropdown
                value={currentFoodAlcoholInteraction && currentFoodAlcoholInteraction.interactionTypeId ? currentFoodAlcoholInteraction.interactionTypeId : -1}
                options={interactionSeverityDropdown}
                onChange={(e) => this.handleInteractionChange('interactionTypeId', e.value)}
                style={{ width: '100%' }}
              />
            </div>
            <div className="p-col-12 p-md-12">
              <label>Consumer description:</label>
              <Editor
                style={{ width: '100%', height: '120px' }}
                onTextChange={(e) => { this.handleContentChange('consumerDecscription', e.htmlValue) }}
                value={this.getDrugToDrugValueContent('consumerDecscription')}
              />
            </div>
            <div className="p-col-12 p-md-12">
              <label>Professional description:</label>
              <Editor
                style={{ width: '100%', height: '120px' }}
                onTextChange={(e) => { this.handleContentChange('professionalDecscription', e.htmlValue) }}
                value={this.getDrugToDrugValueContent('professionalDecscription')}
              />
            </div>
          </div>
        </div>
      </Dialog >
    )
  }
}

export default FoodAlcoholInteractionAddEditDialog;